import { Flex, Text } from "@mantine/core";
import { useCallback } from "react";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";
import { usePostApi } from "src/hooks";
import { useSelector } from "src/redux/hooks";
import { StyledTd, StyledTr } from "src/styled";

import { type IRequest } from "./ReviewComments";

interface Props {
  request: IRequest;
  refetch: () => Promise<void>;
}

const ReviewCommentsRow = ({ request, refetch }: Props) => {
  const isDarkMode = useSelector(state => state.preferencesSlice.isDarkMode);
  const { post, isLoading } = usePostApi();

  const handleAction = useCallback(
    (action: "approve" | "deny") => async () => {
      if (isLoading) return;
      await post({
        request: "update-req-comments",
        body: { params: { action, aid: request.aid } },
      });
      await refetch();
    },
    [isLoading, post, refetch, request.aid],
  );

  return (
    <StyledTr background={isDarkMode ? "transparent" : "white"} hover>
      <StyledTd>{request.requestedBy}</StyledTd>
      <StyledTd>{request.yacht}</StyledTd>
      <StyledTd>{request.requestDate}</StyledTd>
      <StyledTd center>
        <Text color={request.status.color}>{request.status.label}</Text>
      </StyledTd>
      <StyledTd>
        <Flex justify="center" gap="xl">
          <ConfirmationButton
            modalText="Are you sure you want to approve this request?"
            // butto="outline"
            onConfirm={handleAction("approve")}>
            Approve
          </ConfirmationButton>
          <ConfirmationButton
            modalText="Are you sure you want to deny this request?"
            buttonProps={{ color: "red" }}
            onConfirm={handleAction("deny")}>
            Deny
          </ConfirmationButton>
        </Flex>
      </StyledTd>
    </StyledTr>
  );
};

export default ReviewCommentsRow;
